<template>
  <slot></slot>
</template>

<script lang="ts" setup></script>
